import { render, staticRenderFns } from "./ItemMetadata.vue?vue&type=template&id=5f6e5199&scoped=true"
import script from "./ItemMetadata.vue?vue&type=script&lang=js"
export * from "./ItemMetadata.vue?vue&type=script&lang=js"
import style0 from "./ItemMetadata.vue?vue&type=style&index=0&id=5f6e5199&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6e5199",
  null
  
)

export default component.exports